var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.subVerify()}}},[_vm._v("刷新微信公众号菜单")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }